export let Timezones = [
    // {offset: '-11:00', label: '(GMT-11:00) Pago Pago', tzCode: 'Pacific/Pago_Pago'},
    // {offset: '-10:00', label: '(GMT-10:00) Hawaii Time', tzCode: 'Pacific/Honolulu'},
    // {offset: '-10:00', label: '(GMT-10:00) Tahiti', tzCode: 'Pacific/Tahiti'},
    // {offset: '-09:00', label: '(GMT-09:00) Alaska Time', tzCode: 'America/Anchorage'},
    // {offset: '-08:00', label: '(GMT-08:00) Pacific Time', tzCode: 'America/Los_Angeles'},
    // {offset: '-07:00', label: '(GMT-07:00) Mountain Time', tzCode: 'America/Denver'},
    // {offset: '-06:00', label: '(GMT-06:00) Central Time', tzCode: 'America/Chicago'},
    // {offset: '-05:00', label: '(GMT-05:00) Eastern Time', tzCode: 'America/New_York'},
    // {offset: '-04:00', label: '(GMT-04:00) Atlantic Time - Halifax', tzCode: 'America/Halifax'},
    // {offset: '-03:00', label: '(GMT-03:00) Buenos Aires', tzCode: 'America/Argentina/Buenos_Aires'},
    // {offset: '-02:00', label: '(GMT-02:00) Sao Paulo', tzCode: 'America/Sao_Paulo'},
    // {offset: '-01:00', label: '(GMT-01:00) Azores', tzCode: 'Atlantic/Azores'},
    {offset: '+00:00', label: '(GMT+00:00) London', tzCode: 'Europe/London', value: 0.0},
    {offset: '+01:00', label: '(GMT+01:00) Berlin', tzCode: 'Europe/Berlin', value: 1.0},
    {offset: '+02:00', label: '(GMT+02:00) Helsinki', tzCode: 'Europe/Helsinki', value: 2.0},
    {offset: '+03:00', label: '(GMT+03:00) Istanbul', tzCode: 'Europe/Istanbul', value: 3.0},
    {offset: '+04:00', label: '(GMT+04:00) Dubai', tzCode: 'Asia/Dubai', value: 4.0},
    {offset: '+05:00', label: '(GMT+05:00) Maldives', tzCode: 'Indian/Maldives', value: 5.0},
    {offset: '+05:30', label: '(GMT+05:30) Delhi', tzCode: 'India/Delhi', value: 5.5},
    {offset: '+06:00', label: '(GMT+06:00) Dhaka', tzCode: 'Asia/Dhaka', value: 6.0},
    {offset: '+07:00', label: '(GMT+07:00) Bangkok', tzCode: 'Asia/Bangkok', value: 7.0},
    {offset: '+08:00', label: '(GMT+08:00) China Shanghai', tzCode: 'Asia/Shanghai', value: 8.0},
    // {offset: '+09:00', label: '(GMT+09:00) Tokyo', tzCode: 'Asia/Tokyo'},
    // {offset: '+10:00', label: '(GMT+10:00) Eastern Time - Brisbane', tzCode: 'Australia/Brisbane'},
    // {offset: '+11:00', label: '(GMT+11:00) Eastern Time - Melbourne, Sydney', tzCode: 'Australia/Sydney'},
    // {offset: '+12:00', label: '(GMT+12:00) Nauru', tzCode: 'Pacific/Nauru'},
    // {offset: '+13:00', label: '(GMT+13:00) Auckland', tzCode: 'Pacific/Auckland'},
    // {offset: '+14:00', label: '(GMT+14:00) Kiritimati', tzCode: 'Pacific/Kiritimati'}
];

export let TimezoneNumberOffset = function (offset) {
    return parseInt(offset.substr(0, 3))
}

export let BrowserDefaultTimezone = function () {
    return (new Date().getTimezoneOffset() / 60) * -1
}